<app-ui-blocker></app-ui-blocker>

<!-- Global confirm dialog for session timeout warning -->
<p-confirmDialog
  key="sessionTimeout"
  [style]="{ width: '450px' }"
></p-confirmDialog>

@if (showFullpage) {
  <section class="fullpage-container">
    <router-outlet></router-outlet>
  </section>
}

@if (!showFullpage) {
  <p-toast></p-toast>
  <app-layout [module]="leftModule"></app-layout>
}
